import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";
import Button from "../../../../Button";
import Header from "../../../../Header";
import Input from "../../../../Input";
import CallUs from "../CallUs";
import validation from "./validation";

function View({ contact, onSubmit, onClose, locked }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("HELP_MODAL", { returnObjects: true });
  const { t: tErrors } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      ...contact,
      acceptContact: get(contact, "acceptContact") || false,
      acceptDigital: true,
    },
    onSubmit,
    validationSchema: validation(
      tErrors(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });

  const isSubmitDisabled =
    !get(values, `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`) ||
    !get(values, `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`) ||
    !get(values, "acceptContact") ||
    !isEmpty(formProps.errors);

  return (
    <div className="acoris-help-modal__body">
      <Header
        title={
          TRANSLATION?.TITLE ||
          "Renseignez vos informations afin qu'un conseiller puisse prendre contact avec vous"
        }
        highlight={TRANSLATION?.HIGHLIGHT || "Renseignez vos informations"}
      />

      <div className="acoris-form acoris-form--modal">
        <div className="acoris-form__container">
          <div className="acoris-form__row">
            <Input
              placeholder={
                TRANSLATION?.FORM?.PHONE?.PLACEHOLDER || "06 10 20 30 40"
              }
              label={TRANSLATION?.FORM?.PHONE?.LABEL || "N° de téléphone"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                  value,
                );
                setFieldValue(
                  "showAccept",
                  values.showAccept ||
                    !!(
                      value &&
                      get(
                        values,
                        `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                      )
                    ),
                );
              }}
            />
            <Input
              placeholder={
                TRANSLATION?.FORM?.EMAIL?.PLACEHOLDER || "exemple@domaine.fr"
              }
              label={TRANSLATION?.FORM?.EMAIL?.LABEL || "Adresse email"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                values,
                ...formProps,
              })}
              disabled={locked}
              onChange={({ target: { value } }) => {
                setFieldValue(
                  `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                  value,
                );
                setFieldValue(
                  "showAccept",
                  values.showAccept ||
                    !!(
                      value &&
                      get(
                        values,
                        `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                      )
                    ),
                );
              }}
            />
          </div>
          <div className="acoris-form__checkbox-wrapper">
            <Input
              type="checkbox"
              variant="round"
              label={
                TRANSLATION?.CONSENT ||
                "J'autorise ACORIS mutuelles à collecter et utiliser les données personnelles nécessaires à l'exécution de mon devis et une proposition adaptée à mes besoins."
              }
              checked={get(values, "acceptContact") || false}
              onChange={(checked) => {
                setFieldValue("acceptContact", checked);
              }}
              errors={get(formProps.errors, "acceptContact", "")}
              touched={get(formProps.touched, "acceptContact", false)}
              disabled={locked}
            />
          </div>
        </div>

        <CallUs />

        <div className="acoris__actions acoris__actions--modal">
          <Button
            type="primary-outlined"
            className="acoris__actions--close-btn"
            onClick={onClose}
          >
            {TRANSLATION?.BUTTON?.CLOSE || "Fermer"}
          </Button>
          <div className="acoris__actions--primary">
            <Button
              block
              type="primary"
              className="acoris__actions--next"
              disabled={isSubmitDisabled || locked}
              onClick={handleSubmit}
            >
              {TRANSLATION?.BUTTON?.SUBMIT || "Valider mes informations"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
